import React from 'react';
import { Box, Typography, Toolbar, Grid } from '@mui/material';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import Events from '../components/Events';
import { IconButton } from '@mui/material';
import { FaInstagram, FaDiscord, FaEnvelope } from 'react-icons/fa';

const GetInvolved = ({ events = [] }) => {
    return (
        <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: '100vh', }}>
            <Navbar/>
            <Toolbar/>
            <Box sx={{width: '90%', mx: 'auto', flex: 1, py: 4, textAlign: 'center'}}>
                <Typography variant="h2" component="h1" gutterBottom>
                    Get Involved
                </Typography>
                <Typography variant="body1" sx={{textAlign: 'center'}}>
                    To keep up to date with all of our events, be sure to follow us on Instagram or join our Discord!
                    All information regarding club activities will be available on both, as well as any other important updates.
                </Typography>

                <Grid container spacing={2} columns={16} sx={{paddingTop: 5}}>
                    <Grid size={{ xs: 16, md: 8 }}>
                        <Box sx={{textAlign: 'left'}}>
                            <Events events={events} />
                        </Box>
                    </Grid>
                    <Grid size={{ xs: 16, md: 8 }}>
                        <Box>
                            <Typography variant="h3" gutterBottom>
                                Get in Touch
                            </Typography>
                            <IconButton
                                color="inherit"
                                component="a"
                                href="https://www.instagram.com/ncsujsa?utm_source=ig_web_button_share_sheet&igsh=ZDNlZDc0MzIxNw=="
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                <FaInstagram size={64} style={{ color: '#E1306C' }}/>
                            </IconButton>

                            <IconButton
                                color="inherit"
                                component="a"
                                href="https://discord.gg/8AybFXpxwq"
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                <FaDiscord size={64} style={{ color: '#5865F2' }}/>
                            </IconButton>

                            <IconButton
                                color="inherit"
                                component="a"
                                href="mailto:ncstate.jsa@gmail.com"
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                <FaEnvelope size={64} />
                            </IconButton>
                        </Box>
                    </Grid>
                </Grid>
            </Box>
            <Footer/>
        </Box>
    );
};

export default GetInvolved;
